// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-md {
  margin-top: -12px;
}

.refer-input {
  height: 48px;
  border: none;
  max-width: 140px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.remove-padding {
  --padding-start: 0;
  --inner-padding-end: 0;
}

p.warning-label {
  margin: 5px 0;
  font-size: 16px;
  font-weight: bold;
  color: var(--ion-color-danger);
}
p.warning-label ion-icon {
  transform: translateY(4px);
  margin-right: 10px;
}

p.positive-label {
  margin: 5px 0;
  font-size: 16px;
  font-weight: bold;
  color: var(--ion-color-success);
}
p.positive-label ion-icon {
  transform: translateY(4px);
  margin-right: 10px;
}

textarea:focus,
input:focus {
  outline: none;
}

.side-by-button {
  width: 98%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/refer-a-friend/raf-invite-email/raf-invite-email.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AACJ;AACI;EACI,0BAAA;EACA,kBAAA;AACR;;AAGA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AAAJ;AAEI;EACI,0BAAA;EACA,kBAAA;AAAR;;AAIA;;EAEI,aAAA;AADJ;;AAIA;EACI,UAAA;AADJ","sourcesContent":[".list-md {\r\n    margin-top: -12px;\r\n}\r\n\r\n.refer-input {\r\n    height: 48px;\r\n    border: none;\r\n    max-width: 140px;\r\n    text-align: center;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.remove-padding {\r\n    --padding-start: 0;\r\n    --inner-padding-end: 0;\r\n}\r\n\r\np.warning-label {\r\n    margin: 5px 0;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: var(--ion-color-danger);\r\n\r\n    ion-icon {\r\n        transform: translateY(4px);\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\np.positive-label {\r\n    margin: 5px 0;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: var(--ion-color-success);\r\n\r\n    ion-icon {\r\n        transform: translateY(4px);\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\ntextarea:focus,\r\ninput:focus {\r\n    outline: none;\r\n}\r\n\r\n.side-by-button {\r\n    width: 98%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
